import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, EditIcon, BarChartIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: DownloadIcon,
    title: 'Descarga y abre',
    desc: 'Recibes acceso instantáneo. Abre en Excel o Google Sheets (solo editas las celdas amarillas).'
  }, {
    icon: EditIcon,
    title: 'Ingresa tus datos',
    desc: 'Toma 5 minutos poner tu salario y gastos. Viene con ejemplos ya llenos para guiarte.'
  }, {
    icon: BarChartIcon,
    title: 'Mira y ajusta',
    desc: 'Los gráficos se crean solos. Dedica 10 minutos a la semana para ver alertas y ajustar.'
  }];
  return <section className="py-20 px-4 bg-cream" data-id="element-149">
      <div className="max-w-5xl mx-auto" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-151">
          <h2 className="text-3xl md:text-4xl font-bold text-purple-dark mb-4" data-id="element-152">
            Cómo funciona (3 simples pasos)
          </h2>
          <p className="text-lg text-charcoal/70" data-id="element-153">
            Diseñado para mamás ocupadas. Cero complicaciones técnicas.
          </p>
        </motion.div>

        <div className="relative" data-id="element-154">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-24 right-24 h-1 bg-gold/30" data-id="element-155" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-156">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center relative" data-id="element-157">
                <div className="w-24 h-24 bg-white rounded-full shadow-lg border-4 border-gold flex items-center justify-center mb-6 relative" data-id="element-158">
                  <step.icon className="w-10 h-10 text-purple" data-id="element-159" />
                  <div className="absolute -top-3 -right-3 w-8 h-8 bg-purple text-white rounded-full flex items-center justify-center font-bold text-sm" data-id="element-160">
                    {index + 1}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-161">
                  {step.title}
                </h3>
                <p className="text-charcoal/80" data-id="element-162">{step.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}